module.exports = "<div>\r\n\r\n    <text-configuration [(configurations)]=\"configurations.name\"></text-configuration>\r\n \r\n</div>\r\n"